import React from "react"
import { useCustomName } from "hooks"
import { FACILITY_KEY } from "utils/customNameHelpers"
import { auditShape } from "utils/propTypeShapes"
import { AuditedUser } from "shared/audits"

const FacilityCreated = ({ audit }) => {
  const { auditedChanges, comment = "" } = audit

  const { nameInSentence: facilityNameInSentence } = useCustomName(FACILITY_KEY)

  return (
    <div>
      <span>
        <AuditedUser audit={audit} /> added {facilityNameInSentence} <span className="font-semibold">{auditedChanges.name}</span> {comment}
      </span>
    </div>
  )
}

FacilityCreated.propTypes = {
  audit: auditShape.isRequired,
}

export default FacilityCreated
